<template>
  <div>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SignIn",

  methods: {
    goTop() {
      this.$router.push({ path: "/attendance/list" });
    },
  },
});
</script>
